import React from 'react';
import PropTypes from 'prop-types';
import { Formik, Form, Field, CccisdInput } from 'cccisd-formik';
import axios from 'cccisd-axios';
import notification from 'cccisd-notification';
import Loader from 'cccisd-loader';
import Cross from 'cccisd-icons/cross3';
import style from './style.css';

const Boilerplate = window.cccisd.boilerplate;

export default class ParameterSearch extends React.Component {
    static propTypes = {
        closeModal: PropTypes.func,
    };

    modal = React.createRef();

    state = {
        loading: true,
    };

    componentDidMount = async () => {
        this.setState({
            loading: false,
        });
    };

    getInitialValues = settings => {
        return settings;
    };

    // Prevent loss of unsaved changes
    confirmClose = () => {
        this.props.closeModal();
    };

    onSubmit = async (values, actions) => {
        this.setState({
            loading: true,
        });

        let formattedData = values;

        const response = await axios
            .post(Boilerplate.route('api.monitoring.devops.job.parameter-search'), { ...formattedData })
            .catch(() => {
                this.setState({ loading: false });
            });

        this.setState({
            loading: false,
        });

        if (!response || response.data.status !== 'success') {
            notification({ message: 'An error occured', type: 'danger' });
        }

        this.props.closeModal();
    };

    validate = values => {
        const errors = {};

        if (!values.search_string) {
            errors.search_string = 'Search string is required';
        }

        return errors;
    };

    render() {
        const { loading } = this.state;

        if (loading) {
            return <Loader loading />;
        }

        return (
            <>
                <div className={style.replaceClose}>
                    <button className="close" type="button" onClick={this.confirmClose}>
                        <Cross />
                    </button>
                </div>
                <Formik
                    initialValues={{}}
                    validate={this.validate}
                    validateOnChange={false}
                    validateOnBlur={false}
                    onSubmit={this.onSubmit}
                    render={({ values, errors }) => {
                        return (
                            <Form>
                                <div style={{ minHeight: '270px' }}>
                                    <Field
                                        name="search_string"
                                        label="Key to search for in Parameter Store"
                                        component={CccisdInput}
                                    />
                                </div>
                                <div
                                    style={{
                                        display: 'flex',
                                        justifyContent: 'space-between',
                                        marginTop: '1em',
                                    }}
                                >
                                    <button className="btn btn-primary" type="button" onClick={this.confirmClose}>
                                        Cancel
                                    </button>
                                    <button
                                        className="btn btn-primary"
                                        type="submit"
                                        style={{
                                            backgroundColor: '#F0AD4E',
                                            borderColor: '#fff',
                                        }}
                                    >
                                        Search
                                    </button>
                                </div>
                            </Form>
                        );
                    }}
                />
            </>
        );
    }
}
